import { ROUTE } from "@/types/router";

export const LIST_MENU = [
  {
    icon: "/images/settings.png",
    title: "Event Management",
    children: [
      {
        title: "List of Events",
        route: ROUTE.Home,
        screens: [ROUTE.Home, ROUTE.CreateEvent, ROUTE.EditEvent],
      },
    ],
  },
  {
    icon: "/images/gift.png",
    title: "Promotions",
    children: [
      {
        title: "Hotel Discount",
        route: ROUTE.DiscountManagement,
        screens: [
          ROUTE.DiscountManagement,
          ROUTE.CreateDiscount,
          ROUTE.EditDiscount,
        ],
      },
      {
        title: "Flight Discount",
        route: ROUTE.FlightDiscountManagement,
        screens: [
          ROUTE.FlightDiscountManagement,
          ROUTE.CreateFlightDiscount,
          ROUTE.EditFlightDiscount,
        ],
      },
      {
        title: "Booking Points",
        route: ROUTE.BookingPoints,
        screens: [ROUTE.BookingPoints],
      },
      {
        title: "Referral Points",
        route: ROUTE.ReferralPoints,
        screens: [ROUTE.ReferralPoints],
      },
    ],
  },
  {
    icon: "/images/switch-camera.png",
    title: "Refund",
    children: [
      {
        title: "Hotel Booking",
        route: ROUTE.Refund,
        screens: [ROUTE.Refund],
      },
      {
        title: "Flight Booking",
        route: ROUTE.RefundFlight,
        screens: [ROUTE.RefundFlight],
      },
    ],
  },
];

export const JWT_KEY = "JWT_KEY";

export const COOKIE_STORAGE_KEY = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  ADDRESS: "address",
  ACCOUNTS: "accounts",
  RULES: "rules",
};

export enum SEARCH_RESULT_SORT {
  DEFAULT = 1,
  PRICE_LOW_TO_HIGH = 2,
  PRICE_HIGH_TO_LOW = 3,
  STAR_RATING_HIGH_TO_LOW = 4,
  STAR_RATING_LOW_TO_HIGH = 5,
  DISTANCE_NEAR_TO_FAR = 6,
  RATING_HIGH_TO_LOW = 7,
}

export enum VIEW_TYPE {
  GRID = "GRID",
  TABLE = "TABLE",
}

export const DEFAULT_PAGE_SIZE = 12;

export const QUERY_KEY = {
  fetchDiscountList: "fetchDiscountList",
  fetchFeaturedHotel: "fetchFeaturedHotel",
  listCountry: "listCountry",
  listCityByCountry: "listCityByCountry",
  fetchReferralPoints: "fetchReferralPoints",
  fetchDiscountDetail: "fetchDiscountDetail",
  fetchReferralStatistic: "fetchReferralStatistic",
  fetchBookingPoints: "fetchBookingPoints",
  fetchRefundList: "fetchRefundList",
  fetchCancelRefund: "fetchCancelRefund",
  fetchFlightDiscountList: "fetchFlightDiscountList",
  fetchFlightRefundList: "fetchFlightRefundList",
};
